import { render, staticRenderFns } from "./cargoPackingSelect.vue?vue&type=template&id=b0a0374a&"
import script from "./cargoPackingSelect.vue?vue&type=script&lang=js&"
export * from "./cargoPackingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a0374a')) {
      api.createRecord('b0a0374a', component.options)
    } else {
      api.reload('b0a0374a', component.options)
    }
    module.hot.accept("./cargoPackingSelect.vue?vue&type=template&id=b0a0374a&", function () {
      api.rerender('b0a0374a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoPackingSelect.vue"
export default component.exports